$(document).on('click', '.js-about-link', function() {
  const $this = $(this)
  const idx = $this.index()
  const $aboutTabs = $('.js-about-tabs')

  if(!$this.hasClass('is-active')) {
    $this.addClass('is-active').siblings().removeClass('is-active')
    $aboutTabs.find('.js-about-content').eq(idx).fadeIn().siblings().hide()
  }
})